<template>
  <teleport to="head">
    <component :is="'script'" type="application/ld+json">
      { 
        "@context": "https://schema.org",
        "@type": "{{ jsonOptions.type ?? '' }}",
        "headline": "{{ jsonOptions.headline ?? '' }}",
        "datePublished": "{{ jsonOptions.datePublished ?? '' }}",
        "dateModified": "{{ jsonOptions.dateModified ?? '' }}",
        "image": "{{ jsonOptions.image ?? '' }}",
        "author": [{
          "@type": "Organization",
          "name": "{{ jsonOptions.author ?? '' }}",
          "url": "{{ jsonOptions.url ?? '' }}"
        }]        
      }
    </component>
  </teleport>  
</template>

<script lang="ts">
export default {
  name: 'JsonLD',
  props: ['jsonOptions'],
}
</script>

<style scoped></style>
